var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [_c("vue-snotify"), _vm._v(" "), _c("session-timeout")], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }